// extracted by mini-css-extract-plugin
module.exports = {"NoteControl":"NoteControl_NoteControl__31-50"};